/**
 * Project: bicc-ffvt-website-ui
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2022-03-17 09:45:29
 * License: MIT License
 */

import "leaflet/dist/leaflet.css"
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css"

import L from 'leaflet'
import { GestureHandling } from 'leaflet-gesture-handling'

L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling)


export default L
